module.exports = __webpack_public_path__ + "img/9788993094893.abc32409.jpg";